import $ from 'jquery';

/**
 * representative case content
 *
 * @module content-block-cases
 * @version 0.1.1
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-11 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-04 using ChatGPT
 */

class ContentBlockCases {
  constructor(element) {
    this.$el = $(element);
    this.setupDefaults();
    this.setBinds();
  }

  setupDefaults() {
    this.$expandBtn = this.$el.find('.expandTitle');
  }

  setBinds() {
    this.$expandBtn.on('click', (e) => this.handleBtnClick(e));
  }

  handleBtnClick(e) {
    const $currentTarget = $(e.currentTarget);
    $currentTarget.siblings('.expandContentContainer').slideToggle('fast');
    let text = $currentTarget.text();
    if (text.includes('+')) {
      $currentTarget.text(text.replace('+', '-'));
    } else {
      $currentTarget.text(text.replace('-', '+'));
    }
  }
}

export default ContentBlockCases;
